import { render } from "./EstimateSection.vue?vue&type=template&id=2bfe3a8a&scoped=true"
const script = {}

import "./EstimateSection.vue?vue&type=style&index=0&id=2bfe3a8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfe3a8a"]])

export default __exports__